import { render } from "./IsoVoyageTunisie.vue?vue&type=template&id=0dfce2ac"
import script from "./IsoVoyageTunisie.vue?vue&type=script&lang=js"
export * from "./IsoVoyageTunisie.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__